import React, { useState } from 'react';

import { createNotification } from 'backend/MagicBall/Notification';

const NotificationCreateMagicBall = ({ callSuccess, isCreateMode }) => {
  const [resultMessage, setResultMessage] = useState(null);
  
  const [number, setNumber] = useState(0);

  const [titleEn, setTitleEn] = useState('');
  const [contentEn, setContentEn] = useState('');
  const [titleRu, setTitleRu] = useState('');
  const [contentRu, setContentRu] = useState('');
  const [titleUk, setTitleUk] = useState('');
  const [contentUk, setContentUk] = useState('');

  const [titleEs, setTitleEs] = useState('');
  const [contentEs, setContentEs] = useState('');
  const [titlePt, setTitlePt] = useState('');
  const [contentPt, setContentPt] = useState('');
  const [titleIt, setTitleIt] = useState('');
  const [contentIt, setContentIt] = useState('');

  const [titleCs, setTitleCs] = useState('');
  const [contentCs, setContentCs] = useState('');
  const [titleDe, setTitleDe] = useState('');
  const [contentDe, setContentDe] = useState('');
  const [titleFr, setTitleFr] = useState('');
  const [contentFr, setContentFr] = useState('');

  const [titleNl, setTitleNl] = useState('');
  const [contentNl, setContentNl] = useState('');
  const [titlePl, setTitlePl] = useState('');
  const [contentPl, setContentPl] = useState('');
  const [titleTk, setTitleTk] = useState('');
  const [contentTk, setContentTk] = useState('');

  const [titleSl, setTitleSl] = useState('');
  const [contentSl, setContentSl] = useState('');
  const [titleTh, setTitleTh] = useState('');
  const [contentTh, setContentTh] = useState('');
  const [titleHi, setTitleHi] = useState('');
  const [contentHi, setContentHi] = useState('');

  const [titleZh, setTitleZh] = useState('');
  const [contentZh, setContentZh] = useState('');
  const [titleZhCn, setTitleZhCn] = useState('');
  const [contentZhCn, setContentZhCn] = useState('');
  const [titleJa, setTitleJa] = useState('');
  const [contentJa, setContentJa] = useState('');

  const [titleEl, setTitleEl] = useState('');
  const [contentEl, setContentEl] = useState('');
  const [titleSv, setTitleSv] = useState('');
  const [contentSv, setContentSv] = useState('');
  const [titleNo, setTitleNo] = useState('');
  const [contentNo, setContentNo] = useState('');

  const clickOnCreateNotification = () => {
    createNotification(
      number,
      titleEn,
      titleRu,
      titleUk,
      titleEs,
      titlePt,
      titleIt,
      titleCs,
      titleDe,
      titleFr,
      titleNl,
      titlePl,
      titleTk,
      titleSl,
      titleTh,
      titleHi,
      titleZh,
      titleZhCn,
      titleJa,
      titleEl,
      titleSv,
      titleNo,
      contentEn,
      contentRu,
      contentUk,
      contentEs,
      contentPt,
      contentIt,
      contentCs,
      contentDe,
      contentFr,
      contentNl,
      contentPl,
      contentTk,
      contentSl,
      contentTh,
      contentHi,
      contentZh,
      contentZhCn,
      contentJa,
      contentEl,
      contentSv,
      contentNo,
    ).then(() => {
      setResultMessage('Push-нотификация создана! Теперь вы можете совершить рассылку.');
      setTitleEn('');
      setContentEn('');
      setTitleRu('');
      setContentRu('');
      setTitleUk('');
      setContentUk('');
      setTitleEs('');
      setContentEs('');
      setTitlePt('');
      setContentPt('');
      setTitleIt('');
      setContentIt('');
      setTitleCs('');
      setContentCs('');
      setTitleDe('');
      setContentDe('');
      setTitleFr('');
      setContentFr('');
      setTitleNl('');
      setContentNl('');
      setTitlePl('');
      setContentPl('');
      setTitleTk('');
      setContentTk('');
      setTitleSl('');
      setContentSl('');
      setTitleTh('');
      setContentTh('');
      setTitleHi('');
      setContentHi('');
      setTitleZh('');
      setContentZh('');
      setTitleZhCn('');
      setContentZhCn('');
      setTitleJa('');
      setContentJa('');

      setTitleEl('');
      setContentEl('');
      setTitleSv('');
      setContentSv('');
      setTitleNo('');
      setContentNo('');

      callSuccess();
    });
  };

  return (
    <>
    {resultMessage ? (
      <div className="row">
        <div className="col-md-12 text-center">
          <div className="alert alert-success">
            {resultMessage}
          </div>
        </div>
      </div>) : null}
      <div style={{display: isCreateMode}} id="idFormNotification">
        <form className="form-horizontal" role="form">
          <div className="row" style={{paddingTop: 20,}}>
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-en">
                  Название EN 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-en"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleEn} 
                    onChange={(event) => setTitleEn(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-en"> Текст EN </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-en" 
                    className="col-xs-12 col-sm-10"
                    value={contentEn}
                    onChange={(event) => setContentEn(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-ru">
                  Название RU 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-ru"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleRu} 
                    onChange={(event) => setTitleRu(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-ru"> Текст RU </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-ru" 
                    className="col-xs-12 col-sm-10"
                    value={contentRu}
                    onChange={(event) => setContentRu(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-uk">
                  Название UK
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-uk"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleUk} 
                    onChange={(event) => setTitleUk(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-uk"> Текст UK </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-uk" 
                    className="col-xs-12 col-sm-10"
                    value={contentUk}
                    onChange={(event) => setContentUk(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-es">
                  Название ES 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-es"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleEs} 
                    onChange={(event) => setTitleEs(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-es"> Текст ES </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-es" 
                    className="col-xs-12 col-sm-10"
                    value={contentEs}
                    onChange={(event) => setContentEs(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-pt">
                  Название PT
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-pt"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titlePt} 
                    onChange={(event) => setTitlePt(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-pt"> Текст PT </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-pt" 
                    className="col-xs-12 col-sm-10"
                    value={contentPt}
                    onChange={(event) => setContentPt(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-it">
                  Название IT
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-it"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleIt} 
                    onChange={(event) => setTitleIt(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-it"> Текст IT </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-it" 
                    className="col-xs-12 col-sm-10"
                    value={contentIt}
                    onChange={(event) => setContentIt(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-cs">
                  Название CS 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-cs"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleCs} 
                    onChange={(event) => setTitleCs(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-cs"> Текст CS </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-cs" 
                    className="col-xs-12 col-sm-10"
                    value={contentCs}
                    onChange={(event) => setContentCs(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-de">
                  Название DE
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-de"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleDe} 
                    onChange={(event) => setTitleDe(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-de"> Текст DE </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-de" 
                    className="col-xs-12 col-sm-10"
                    value={contentDe}
                    onChange={(event) => setContentDe(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-fr">
                  Название FR
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-fr"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleFr} 
                    onChange={(event) => setTitleFr(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-fr"> Текст FR </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-fr" 
                    className="col-xs-12 col-sm-10"
                    value={contentFr}
                    onChange={(event) => setContentFr(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          
          <hr />

          <div className="row">
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-nl">
                  Название NL
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-nl"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleNl} 
                    onChange={(event) => setTitleNl(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-nl"> Текст NL </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-nl" 
                    className="col-xs-12 col-sm-10"
                    value={contentNl}
                    onChange={(event) => setContentNl(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-pl">
                  Название PL
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-pl"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titlePl} 
                    onChange={(event) => setTitlePl(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-pl"> Текст PL </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-pl" 
                    className="col-xs-12 col-sm-10"
                    value={contentPl}
                    onChange={(event) => setContentPl(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-tk">
                  Название TK
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-tk"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleTk} 
                    onChange={(event) => setTitleTk(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-tk"> Текст TK </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-tk" 
                    className="col-xs-12 col-sm-10"
                    value={contentTk}
                    onChange={(event) => setContentTk(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-sl">
                  Название SL 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-sl"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleSl} 
                    onChange={(event) => setTitleSl(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-sl"> Текст SL </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-sl" 
                    className="col-xs-12 col-sm-10"
                    value={contentSl}
                    onChange={(event) => setContentSl(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-hi">
                  Название HI
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-hi"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleHi} 
                    onChange={(event) => setTitleHi(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-hi"> Текст HI </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-hi" 
                    className="col-xs-12 col-sm-10"
                    value={contentHi}
                    onChange={(event) => setContentHi(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-th">
                  Название TH
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-th"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleTh} 
                    onChange={(event) => setTitleTh(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-th"> Текст TH </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-th" 
                    className="col-xs-12 col-sm-10"
                    value={contentTh}
                    onChange={(event) => setContentTh(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-zh">
                  Название ZH
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-zh"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleZh} 
                    onChange={(event) => setTitleZh(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-zh"> Текст ZH </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-zh" 
                    className="col-xs-12 col-sm-10"
                    value={contentZh}
                    onChange={(event) => setContentZh(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-zhCn">
                  Название ZH-CN
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-zhCn"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleZhCn} 
                    onChange={(event) => setTitleZhCn(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-zhCn"> Текст ZH-CN </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-zhCn" 
                    className="col-xs-12 col-sm-10"
                    value={contentZhCn}
                    onChange={(event) => setContentZhCn(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-ja">
                  Название JA
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-ja"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleJa} 
                    onChange={(event) => setTitleJa(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-ja"> Текст JA </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-ja" 
                    className="col-xs-12 col-sm-10"
                    value={contentJa}
                    onChange={(event) => setContentJa(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="row" style={{paddingTop: 20,}}>
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-el">
                  Название EL 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-el"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleEl} 
                    onChange={(event) => setTitleEl(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-el"> Текст EL </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-el" 
                    className="col-xs-12 col-sm-10"
                    value={contentEl}
                    onChange={(event) => setContentEl(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-sv">
                  Название SV
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-sv"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleSv} 
                    onChange={(event) => setTitleSv(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-sv"> Текст SV </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-sv" 
                    className="col-xs-12 col-sm-10"
                    value={contentSv}
                    onChange={(event) => setContentSv(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-no">
                  Название NO
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-no"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleNo} 
                    onChange={(event) => setTitleNo(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-no"> Текст NO </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-no" 
                    className="col-xs-12 col-sm-10"
                    value={contentNo}
                    onChange={(event) => setContentNo(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-5">
              <div className="form-group">
                <label className="col-sm-6 control-label no-padding-right" htmlFor="form-number">
                  Последовательность отправки
                </label>
                <div className="col-sm-6">
                  <input
                    id="form-number"
                    type="text"
                    className="col-xs-9 col-sm-9"
                    value={number} 
                    onChange={(event) => setNumber(event.target.value)} 
                  />
                </div>
              </div>
            </div>
            <div className="col-md-5 text-right">
              <button className="btn btn-info" type="button" onClick={() => clickOnCreateNotification()}>
                <i className="ace-icon fa fa-check bigger-110"></i>
                Сохранить
              </button>
            </div>
          </div>
        </form>
        <hr />
      </div>
    </>
  );
};

export default NotificationCreateMagicBall;
